import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { StringFilter } from 'src/app/filter/filter';
import { Job } from './job.resource';
import { AtomService } from '../atom.service';
import { Enum } from './enum.resource';
import { Firm } from './firm.resource';
import { Product } from './product.resource';
import { Shortcode } from './shortcode.ressource';
import { Keyword } from './keyword.ressource';
import { Lang } from './lang.resource';
import { Kinematic } from './kinematic.resource';
import { OrderChannel } from './order-channel.resource';
import { Pack } from './pack.resource';
import { Offer } from './offer.resource';
import {
  ResourceConfig,
  ResourceConfigOne,
} from 'src/app/resources/resources-interfaces/resource-config';
import {
  BillingKinematicConfig,
  FirmConfig,
  LangConfig,
  OfferConfig,
  OrderChannelConfig,
  PackConfig,
  ProductConfig,
} from 'src/app/shared/tools/search/search-config';

@Resource({
  type: 'keywordrulesdvp4m',
})
export class Keywordrulesdvp4m extends AtomResource {
  @Attribute() action?: Enum;
  @Attribute() mode?: Enum;
  @Attribute() message?: string;
  @Attribute() blacklist?: boolean;
  @Attribute() step?: Enum;
  @Attribute() data?: Record<string, unknown>;

  @Relationship() keyword?: Keyword;
  @Relationship() lang?: Lang;
  @Relationship() kinematic?: Kinematic;
  @Relationship() orderchannel?: OrderChannel;
  @Relationship() pack?: Pack;
  @Relationship() legalfirm?: Firm;
  @Relationship() products?: Product[];
  @Relationship() offers?: Offer[];
}
export class Keywordrulesdvp4mConfig implements ResourceConfig {
  hosted = 'keyword';
  required = true;
  tables = {};
  detail = {
    header: {
      icon: 'rule',
      title: [
        {
          path: ['action'],
          translatable: true,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        columns: true,
        list: [
          {
            icon: 'more_vert',
            title: 'Action',
            APIKey: 'action',
            value: {
              path: ['action'],
              translatable: false,
            },
          },
          {
            icon: 'inventory',
            title: 'Pack',
            APIKey: 'pack',
            value: {
              path: ['pack.id'],
              translatable: false,
            },
            link: {
              resource: 'packs',
              filter: 'pack.id',
            },
          },
          {
            icon: 'public',
            type: 'chips',
            title: 'Products',
            APIKey: 'products',
            value: {
              path: ['name'],
              translatable: true,
            },
            link: {
              resource: 'products',
              filter: 'product.id',
            },
          },
          {
            icon: 'radio_button_checked',
            title: 'Order Channel',
            APIKey: 'orderchannel',
            value: {
              path: ['orderchannel.name'],
              translatable: true,
            },
          },
          {
            icon: 'message',
            title: 'Message',
            APIKey: 'message',
            value: {
              path: ['message'],
              translatable: false,
            },
          },

          {
            icon: 'auto_mode',
            title: 'Mode',
            APIKey: 'mode',
            value: {
              path: ['mode'],
              translatable: false,
            },
          },
          {
            icon: 'translate',
            title: 'Lang',
            APIKey: 'lang',
            value: {
              path: ['lang.name'],
              translatable: true,
            },
          },
          {
            icon: 'local_offer',
            type: 'chips',
            title: 'Offers',
            APIKey: 'offers',
            value: {
              path: ['name'],
              translatable: true,
            },
            link: {
              resource: 'offers',
              filter: 'offer.id',
            },
          },
          {
            icon: 'radio_button_checked',
            title: 'Kinematic',
            APIKey: 'kinematic',
            value: {
              path: ['kinematic.name'],
              translatable: true,
            },
          },
          {
            icon: 'filter_1',
            title: 'Step',
            APIKey: 'step',
            value: {
              path: ['step'],
            },
          },
          {
            icon: 'business',
            title: 'Legal Firm',
            APIKey: 'legalfirm',
            value: {
              path: ['legalfirm.name'],
              translatable: true,
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'DVP4M Rules',
        formGroup: 'dvp4mrules',
        list: [
          {
            type: 'enum',
            title: 'Action',
            formControl: 'action',
            APIKey: 'action',
            fieldKey: 'action',
            required: true,
            activatingSequence: [
              {
                group: 'dvp4mrules',
                control: 'mode',
                condition: { include: ['cancellation'] },
              },
              {
                group: 'dvp4mrules',
                control: 'kinematic',
                condition: {
                  include: ['subscription', 'oneshot', 'cancellation'],
                },
              },
              {
                group: 'dvp4mrules',
                control: 'orderchannel',
                condition: {
                  include: ['subscription', 'oneshot', 'cancellation'],
                },
              },
              {
                group: 'dvp4mrules',
                control: 'pack',
                condition: { include: ['subscription', 'oneshot'] },
              },
              {
                group: 'dvp4mrules',
                control: 'message',
                condition: { include: ['message'] },
              },
              {
                group: 'dvp4mrules',
                control: 'blacklist',
                condition: { include: ['cancellation'] },
              },
            ],
          },
          {
            type: 'enum',
            title: 'Mode',
            formControl: 'mode',
            APIKey: 'mode',
            fieldKey: 'mode',
            activatingSequence: [
              {
                group: 'dvp4mrules',
                control: 'legalfirm',
                condition: { include: ['legal'] },
              },
              {
                group: 'dvp4mrules',
                control: 'products',
                condition: { include: ['products'] },
              },
              {
                group: 'dvp4mrules',
                control: 'offers',
                condition: { include: ['offers'] },
              },
            ],
          },
          {
            type: 'resource',
            title: 'Kinematic',
            formControl: 'kinematic',
            search: new BillingKinematicConfig(),
            activatingSequence: [
              {
                group: 'dvp4mrules',
                control: 'step',
                type: 'resource',
                condition: { include: ['6', '8'] },
              },
            ],
          },
          {
            type: 'enum',
            title: 'Step',
            formControl: 'step',
            APIKey: 'step',
            fieldKey: 'step',
          },
          {
            type: 'resource',
            title: 'Order Channel',
            formControl: 'orderchannel',
            search: new OrderChannelConfig(),
          },
          {
            type: 'resource',
            title: 'Pack',
            formControl: 'pack',
            search: new PackConfig(),
            noCols: true,
            hint: 'Prohibited if step = 2',
            filter: [
              {
                key: 'like.packoffers.offer.country.id',
                value: 'keyword.shortcode.country.id',
              },
            ],
          },
          {
            type: 'resource',
            title: 'Lang',
            formControl: 'lang',
            search: new LangConfig(this.atom),
            required: true,
            noCols: true,
            filter: [
              {
                key: 'like.countries.id',
                value: 'keyword.shortcode.country.id',
                fixValue: 'US',
              },
            ],
          },
          {
            type: 'resource',
            title: 'Legal Firm',
            formControl: 'legalfirm',
            search: new FirmConfig(this.atom),
            noCols: true,
          },
          {
            type: 'resource',
            title: 'Products',
            formControl: 'products',
            multiple: true,
            search: new ProductConfig(this.atom, true),
            noCols: true,
            filter: [
              {
                key: 'like.country.id',
                value: 'keyword.shortcode.country.id',
              },
            ],
          },
          {
            type: 'resource',
            title: 'Offers',
            formControl: 'offers',
            multiple: true,
            search: new OfferConfig(this.atom, true),
            noCols: true,
            filter: [
              {
                key: 'equal.enduserproviderjob.id',
                value: 'keyword.shortcode.enduserproviderjob.id',
              },
            ],
          },
          {
            type: 'text',
            title: 'Message',
            formControl: 'message',
            noCols: true,
          },
          {
            type: 'boolean',
            title: 'Blacklist ?',
            formControl: 'blacklist',
            noCols: true,
            presetValue: false,
          },
        ],
      },
    ],
  };
  resource = Keywordrulesdvp4m;
  resourceName = 'Keyword Rules DVP4M';
  resourceKey = 'keywordrulesdvp4m';
  resourceKeySingle = 'keywordrulesdvp4m';
  includes = [
    'lang',
    'kinematic',
    'orderchannel',
    'pack',
    'legalfirm',
    'products',
    'offers',
    'keyword.shortcode.country',
    'keyword.shortcode.enduserproviderjob',
  ];
  filters = [
    new StringFilter('id', 'ID', true),
    new StringFilter('name', 'Name'),
    new StringFilter('shortcode.country.id', 'Country ID'),
    new StringFilter(
      'keyword.shortcode.enduserproviderjob.id',
      'Enduserprovider ID'
    ),
  ];
  constructor(private atom: AtomService) {}
}
